export type Settled<T> =
  | { status: "fulfilled"; value: T }
  | { status: "rejected"; reason: unknown };

const fulfilled = <T>(value: T): Settled<T> => ({
  status: "fulfilled",
  value,
});

const rejected = (reason: unknown): Settled<never> => ({
  status: "rejected",
  reason,
});

export const allSettledPromise = <T>(
  promises: Promise<T>[]
): Promise<Settled<T>[]> => {
  return Promise.all(
    promises.map(p => p.then(fulfilled).catch(rejected))
  );
};
